import React from "react";
import { Card, Select, Button, Table } from "antd";
import EmployeeOnLeaveService from "Services/AdminServices/ReportServices/EmployeeOnLeaveService";
import PropTypes from "prop-types";

const { Option } = Select;

export default function EmployeesOnLeave({ upcomingOnly = false }) {
  const {
    columns,
    filteredRows,
    handleDownloadReport,
    handleDepartmentChange,
    departments,
    selectedDepartment,
  } = EmployeeOnLeaveService(upcomingOnly);

  return (
    <Card
      title={upcomingOnly ? "Upcoming Employee Leaves" : "Employee on Leave"}
      className="clean-card"
      extra={
        <>
          <Button type="default" onClick={handleDownloadReport} style={{ marginRight: "16px" }}>
            <i className="fa fa-download" aria-hidden="true"></i>&nbsp; Download Employee Reports
          </Button>

          <Select
            value={selectedDepartment}
            onChange={handleDepartmentChange}
            style={{ width: 200 }}
            placeholder="All Departments"
          >
             <Option value={null}>All Departments</Option>
            {departments.map((dept) => (
              <Option key={dept.id || dept.departmentId} value={dept.id || dept.departmentId}>
                {dept.name || dept.departmentName}
              </Option>
            ))}
          </Select>
        </>
      }
    >
      <Table
        bordered
        className="custom-table"
        dataSource={filteredRows}
        columns={columns}
        pagination={{ pageSize: 10 }}
        rowKey="id"
      />
    </Card>
  );
}
EmployeesOnLeave.propTypes = {
  upcomingOnly: PropTypes.bool, // validate optional boolean prop
};
